import { connect } from 'react-redux';
import { IState } from '../../../../../store/types';
import { getTargetCaptions } from '../../../../../store/videos/selectors';
import { getAudioPlayerState } from '../../../../../store/general/selectors';
import { getLessonPlayback } from '../../../selectors/getLessonPlayback';
import { AudioPlayerStates } from '../../../../../types/common';
import { LessonTranscript } from '../components/LessonTranscript';
import { ILessonTranscriptFields, ILessonTranscriptOwnProps } from '../components/types';

const mapStateToProps = (
	state: IState
): ILessonTranscriptFields => {
	return {
		captions: getTargetCaptions(state),
		// TTS (text lessons) doesn't report its state to the store; no media — nothing plays
		isPlaying: getLessonPlayback(state) === 'media'
			? getAudioPlayerState(state) === AudioPlayerStates.PLAYING
			: null,
	};
};

export const LessonTranscriptHOC = connect<ILessonTranscriptFields, {}, ILessonTranscriptOwnProps, IState>(
	mapStateToProps
)(LessonTranscript);

LessonTranscriptHOC.displayName = 'LessonTranscriptHOC';
